/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanySearchInternshipEmail,
  MapAheadResponse,
  MessageResponse,
  PortalFilterResponse,
  SearchResultCollection,
} from '../models/index';
import {
    CompanySearchInternshipEmailFromJSON,
    CompanySearchInternshipEmailToJSON,
    MapAheadResponseFromJSON,
    MapAheadResponseToJSON,
    MessageResponseFromJSON,
    MessageResponseToJSON,
    PortalFilterResponseFromJSON,
    PortalFilterResponseToJSON,
    SearchResultCollectionFromJSON,
    SearchResultCollectionToJSON,
} from '../models/index';

export interface ExportRequest {
    country?: string;
    companyNames?: Array<string>;
    companyName?: string;
    partialIndustryCode?: boolean;
    industryCodes?: Array<string>;
    municipalities?: Array<string>;
    postalCode?: string;
    postalCodeEnd?: string;
    postalCodeIn?: string;
    latitude?: number;
    longitude?: number;
    latitude2?: number;
    longitude2?: number;
    maxDistance?: number;
    staffNumberFrom?: number;
    staffNumberTo?: number;
    staffNumberMax?: boolean;
    turnoverFrom?: number;
    turnoverTo?: number;
    turnoverMax?: boolean;
    limit?: number;
    offset?: number;
    order?: string;
    orderDirection?: string;
    searchByAddresses?: boolean;
    fullSearch?: boolean;
    searchContains?: boolean;
    searchExact?: boolean;
    addressType?: string;
    officeIds?: Array<string>;
    companyIds?: Array<string>;
    companyId?: string;
    countOnly?: boolean;
    address?: string;
    cities?: Array<string>;
    includeDetails?: boolean;
    fromCompanySearchFocus?: boolean;
    fileName?: string;
    userId?: string;
    fromFavorites?: boolean;
}

export interface CreateSavedCompanyRequest {
    userId?: string;
    companyId?: string;
    officeId?: string;
    companyCountry?: string;
    note?: string;
    isInsertedMainCompany?: boolean;
    vainuCompany?: any;
}

export interface DeleteSavedCompanyRequest {
    userId?: string;
    companyId?: string;
    officeId?: string;
    companyCountry?: string;
    note?: string;
    isInsertedMainCompany?: boolean;
    vainuCompany?: any;
}

export interface ExportSavedCompaniesRequest {
    country?: string;
    companyNames?: Array<string>;
    companyName?: string;
    partialIndustryCode?: boolean;
    industryCodes?: Array<string>;
    municipalities?: Array<string>;
    postalCode?: string;
    postalCodeEnd?: string;
    postalCodeIn?: string;
    latitude?: number;
    longitude?: number;
    latitude2?: number;
    longitude2?: number;
    maxDistance?: number;
    staffNumberFrom?: number;
    staffNumberTo?: number;
    staffNumberMax?: boolean;
    turnoverFrom?: number;
    turnoverTo?: number;
    turnoverMax?: boolean;
    limit?: number;
    offset?: number;
    order?: string;
    orderDirection?: string;
    searchByAddresses?: boolean;
    fullSearch?: boolean;
    searchContains?: boolean;
    searchExact?: boolean;
    addressType?: string;
    officeIds?: Array<string>;
    companyIds?: Array<string>;
    companyId?: string;
    countOnly?: boolean;
    address?: string;
    cities?: Array<string>;
    includeDetails?: boolean;
    fromCompanySearchFocus?: boolean;
    fileName?: string;
    userId?: string;
    fromFavorites?: boolean;
}

export interface ExportToMyDocumentsRequest {
    country?: string;
    companyNames?: Array<string>;
    companyName?: string;
    partialIndustryCode?: boolean;
    industryCodes?: Array<string>;
    municipalities?: Array<string>;
    postalCode?: string;
    postalCodeEnd?: string;
    postalCodeIn?: string;
    latitude?: number;
    longitude?: number;
    latitude2?: number;
    longitude2?: number;
    maxDistance?: number;
    staffNumberFrom?: number;
    staffNumberTo?: number;
    staffNumberMax?: boolean;
    turnoverFrom?: number;
    turnoverTo?: number;
    turnoverMax?: boolean;
    limit?: number;
    offset?: number;
    order?: string;
    orderDirection?: string;
    searchByAddresses?: boolean;
    fullSearch?: boolean;
    searchContains?: boolean;
    searchExact?: boolean;
    addressType?: string;
    officeIds?: Array<string>;
    companyIds?: Array<string>;
    companyId?: string;
    countOnly?: boolean;
    address?: string;
    cities?: Array<string>;
    includeDetails?: boolean;
    fromCompanySearchFocus?: boolean;
    fileName?: string;
    userId?: string;
    fromFavorites?: boolean;
}

export interface GetFiltersRequest {
    country?: string;
}

export interface GetFinancialStatementsRequest {
    country?: string;
    companyNames?: Array<string>;
    companyName?: string;
    partialIndustryCode?: boolean;
    industryCodes?: Array<string>;
    municipalities?: Array<string>;
    postalCode?: string;
    postalCodeEnd?: string;
    postalCodeIn?: string;
    latitude?: number;
    longitude?: number;
    latitude2?: number;
    longitude2?: number;
    maxDistance?: number;
    staffNumberFrom?: number;
    staffNumberTo?: number;
    staffNumberMax?: boolean;
    turnoverFrom?: number;
    turnoverTo?: number;
    turnoverMax?: boolean;
    limit?: number;
    offset?: number;
    order?: string;
    orderDirection?: string;
    searchByAddresses?: boolean;
    fullSearch?: boolean;
    searchContains?: boolean;
    searchExact?: boolean;
    addressType?: string;
    officeIds?: Array<string>;
    companyIds?: Array<string>;
    companyId?: string;
    countOnly?: boolean;
    address?: string;
    cities?: Array<string>;
    includeDetails?: boolean;
    fromCompanySearchFocus?: boolean;
    fileName?: string;
    userId?: string;
    fromFavorites?: boolean;
}

export interface GetMapAheadRequest {
    country?: string;
    companyNames?: Array<string>;
    companyName?: string;
    partialIndustryCode?: boolean;
    industryCodes?: Array<string>;
    municipalities?: Array<string>;
    postalCode?: string;
    postalCodeEnd?: string;
    postalCodeIn?: string;
    latitude?: number;
    longitude?: number;
    latitude2?: number;
    longitude2?: number;
    maxDistance?: number;
    staffNumberFrom?: number;
    staffNumberTo?: number;
    staffNumberMax?: boolean;
    turnoverFrom?: number;
    turnoverTo?: number;
    turnoverMax?: boolean;
    limit?: number;
    offset?: number;
    order?: string;
    orderDirection?: string;
    searchByAddresses?: boolean;
    fullSearch?: boolean;
    searchContains?: boolean;
    searchExact?: boolean;
    addressType?: string;
    officeIds?: Array<string>;
    companyIds?: Array<string>;
    companyId?: string;
    countOnly?: boolean;
    address?: string;
    cities?: Array<string>;
    includeDetails?: boolean;
    fromCompanySearchFocus?: boolean;
    fileName?: string;
    userId?: string;
    fromFavorites?: boolean;
}

export interface GetSavedCompaniesRequest {
    userId?: string;
}

export interface SearchRequest {
    country?: string;
    companyNames?: Array<string>;
    companyName?: string;
    partialIndustryCode?: boolean;
    industryCodes?: Array<string>;
    municipalities?: Array<string>;
    postalCode?: string;
    postalCodeEnd?: string;
    postalCodeIn?: string;
    latitude?: number;
    longitude?: number;
    latitude2?: number;
    longitude2?: number;
    maxDistance?: number;
    staffNumberFrom?: number;
    staffNumberTo?: number;
    staffNumberMax?: boolean;
    turnoverFrom?: number;
    turnoverTo?: number;
    turnoverMax?: boolean;
    limit?: number;
    offset?: number;
    order?: string;
    orderDirection?: string;
    searchByAddresses?: boolean;
    fullSearch?: boolean;
    searchContains?: boolean;
    searchExact?: boolean;
    addressType?: string;
    officeIds?: Array<string>;
    companyIds?: Array<string>;
    companyId?: string;
    countOnly?: boolean;
    address?: string;
    cities?: Array<string>;
    includeDetails?: boolean;
    fromCompanySearchFocus?: boolean;
    fileName?: string;
    userId?: string;
    fromFavorites?: boolean;
}

export interface SendInternshipEmailToCounsellorRequest {
    companySearchInternshipEmail?: CompanySearchInternshipEmail;
}

export interface UpdateSavedCompanyRequest {
    userId?: string;
    companyId?: string;
    officeId?: string;
    companyCountry?: string;
    note?: string;
    isInsertedMainCompany?: boolean;
    vainuCompany?: any;
}

/**
 * 
 */
export class CompanySearchApi extends runtime.BaseAPI {

    /**
     */
    async _exportRaw(requestParameters: ExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.country !== undefined) {
            queryParameters['Country'] = requestParameters.country;
        }

        if (requestParameters.companyNames) {
            queryParameters['CompanyNames'] = requestParameters.companyNames;
        }

        if (requestParameters.companyName !== undefined) {
            queryParameters['CompanyName'] = requestParameters.companyName;
        }

        if (requestParameters.partialIndustryCode !== undefined) {
            queryParameters['PartialIndustryCode'] = requestParameters.partialIndustryCode;
        }

        if (requestParameters.industryCodes) {
            queryParameters['IndustryCodes'] = requestParameters.industryCodes;
        }

        if (requestParameters.municipalities) {
            queryParameters['Municipalities'] = requestParameters.municipalities;
        }

        if (requestParameters.postalCode !== undefined) {
            queryParameters['PostalCode'] = requestParameters.postalCode;
        }

        if (requestParameters.postalCodeEnd !== undefined) {
            queryParameters['PostalCodeEnd'] = requestParameters.postalCodeEnd;
        }

        if (requestParameters.postalCodeIn !== undefined) {
            queryParameters['PostalCodeIn'] = requestParameters.postalCodeIn;
        }

        if (requestParameters.latitude !== undefined) {
            queryParameters['Latitude'] = requestParameters.latitude;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['Longitude'] = requestParameters.longitude;
        }

        if (requestParameters.latitude2 !== undefined) {
            queryParameters['Latitude2'] = requestParameters.latitude2;
        }

        if (requestParameters.longitude2 !== undefined) {
            queryParameters['Longitude2'] = requestParameters.longitude2;
        }

        if (requestParameters.maxDistance !== undefined) {
            queryParameters['MaxDistance'] = requestParameters.maxDistance;
        }

        if (requestParameters.staffNumberFrom !== undefined) {
            queryParameters['StaffNumberFrom'] = requestParameters.staffNumberFrom;
        }

        if (requestParameters.staffNumberTo !== undefined) {
            queryParameters['StaffNumberTo'] = requestParameters.staffNumberTo;
        }

        if (requestParameters.staffNumberMax !== undefined) {
            queryParameters['StaffNumberMax'] = requestParameters.staffNumberMax;
        }

        if (requestParameters.turnoverFrom !== undefined) {
            queryParameters['TurnoverFrom'] = requestParameters.turnoverFrom;
        }

        if (requestParameters.turnoverTo !== undefined) {
            queryParameters['TurnoverTo'] = requestParameters.turnoverTo;
        }

        if (requestParameters.turnoverMax !== undefined) {
            queryParameters['TurnoverMax'] = requestParameters.turnoverMax;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['Offset'] = requestParameters.offset;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['Order'] = requestParameters.order;
        }

        if (requestParameters.orderDirection !== undefined) {
            queryParameters['OrderDirection'] = requestParameters.orderDirection;
        }

        if (requestParameters.searchByAddresses !== undefined) {
            queryParameters['SearchByAddresses'] = requestParameters.searchByAddresses;
        }

        if (requestParameters.fullSearch !== undefined) {
            queryParameters['FullSearch'] = requestParameters.fullSearch;
        }

        if (requestParameters.searchContains !== undefined) {
            queryParameters['SearchContains'] = requestParameters.searchContains;
        }

        if (requestParameters.searchExact !== undefined) {
            queryParameters['SearchExact'] = requestParameters.searchExact;
        }

        if (requestParameters.addressType !== undefined) {
            queryParameters['AddressType'] = requestParameters.addressType;
        }

        if (requestParameters.officeIds) {
            queryParameters['OfficeIds'] = requestParameters.officeIds;
        }

        if (requestParameters.companyIds) {
            queryParameters['CompanyIds'] = requestParameters.companyIds;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.countOnly !== undefined) {
            queryParameters['CountOnly'] = requestParameters.countOnly;
        }

        if (requestParameters.address !== undefined) {
            queryParameters['Address'] = requestParameters.address;
        }

        if (requestParameters.cities) {
            queryParameters['Cities'] = requestParameters.cities;
        }

        if (requestParameters.includeDetails !== undefined) {
            queryParameters['IncludeDetails'] = requestParameters.includeDetails;
        }

        if (requestParameters.fromCompanySearchFocus !== undefined) {
            queryParameters['FromCompanySearchFocus'] = requestParameters.fromCompanySearchFocus;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['FileName'] = requestParameters.fileName;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.fromFavorites !== undefined) {
            queryParameters['FromFavorites'] = requestParameters.fromFavorites;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/Export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async _export(requestParameters: ExportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this._exportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createSavedCompanyRaw(requestParameters: CreateSavedCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.officeId !== undefined) {
            queryParameters['OfficeId'] = requestParameters.officeId;
        }

        if (requestParameters.companyCountry !== undefined) {
            queryParameters['CompanyCountry'] = requestParameters.companyCountry;
        }

        if (requestParameters.note !== undefined) {
            queryParameters['Note'] = requestParameters.note;
        }

        if (requestParameters.isInsertedMainCompany !== undefined) {
            queryParameters['isInsertedMainCompany'] = requestParameters.isInsertedMainCompany;
        }

        if (requestParameters.vainuCompany !== undefined) {
            queryParameters['VainuCompany'] = requestParameters.vainuCompany;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/CreateSavedCompany`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createSavedCompany(requestParameters: CreateSavedCompanyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.createSavedCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteSavedCompanyRaw(requestParameters: DeleteSavedCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.officeId !== undefined) {
            queryParameters['OfficeId'] = requestParameters.officeId;
        }

        if (requestParameters.companyCountry !== undefined) {
            queryParameters['CompanyCountry'] = requestParameters.companyCountry;
        }

        if (requestParameters.note !== undefined) {
            queryParameters['Note'] = requestParameters.note;
        }

        if (requestParameters.isInsertedMainCompany !== undefined) {
            queryParameters['isInsertedMainCompany'] = requestParameters.isInsertedMainCompany;
        }

        if (requestParameters.vainuCompany !== undefined) {
            queryParameters['VainuCompany'] = requestParameters.vainuCompany;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/DeleteSavedCompany`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteSavedCompany(requestParameters: DeleteSavedCompanyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.deleteSavedCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exportSavedCompaniesRaw(requestParameters: ExportSavedCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.country !== undefined) {
            queryParameters['Country'] = requestParameters.country;
        }

        if (requestParameters.companyNames) {
            queryParameters['CompanyNames'] = requestParameters.companyNames;
        }

        if (requestParameters.companyName !== undefined) {
            queryParameters['CompanyName'] = requestParameters.companyName;
        }

        if (requestParameters.partialIndustryCode !== undefined) {
            queryParameters['PartialIndustryCode'] = requestParameters.partialIndustryCode;
        }

        if (requestParameters.industryCodes) {
            queryParameters['IndustryCodes'] = requestParameters.industryCodes;
        }

        if (requestParameters.municipalities) {
            queryParameters['Municipalities'] = requestParameters.municipalities;
        }

        if (requestParameters.postalCode !== undefined) {
            queryParameters['PostalCode'] = requestParameters.postalCode;
        }

        if (requestParameters.postalCodeEnd !== undefined) {
            queryParameters['PostalCodeEnd'] = requestParameters.postalCodeEnd;
        }

        if (requestParameters.postalCodeIn !== undefined) {
            queryParameters['PostalCodeIn'] = requestParameters.postalCodeIn;
        }

        if (requestParameters.latitude !== undefined) {
            queryParameters['Latitude'] = requestParameters.latitude;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['Longitude'] = requestParameters.longitude;
        }

        if (requestParameters.latitude2 !== undefined) {
            queryParameters['Latitude2'] = requestParameters.latitude2;
        }

        if (requestParameters.longitude2 !== undefined) {
            queryParameters['Longitude2'] = requestParameters.longitude2;
        }

        if (requestParameters.maxDistance !== undefined) {
            queryParameters['MaxDistance'] = requestParameters.maxDistance;
        }

        if (requestParameters.staffNumberFrom !== undefined) {
            queryParameters['StaffNumberFrom'] = requestParameters.staffNumberFrom;
        }

        if (requestParameters.staffNumberTo !== undefined) {
            queryParameters['StaffNumberTo'] = requestParameters.staffNumberTo;
        }

        if (requestParameters.staffNumberMax !== undefined) {
            queryParameters['StaffNumberMax'] = requestParameters.staffNumberMax;
        }

        if (requestParameters.turnoverFrom !== undefined) {
            queryParameters['TurnoverFrom'] = requestParameters.turnoverFrom;
        }

        if (requestParameters.turnoverTo !== undefined) {
            queryParameters['TurnoverTo'] = requestParameters.turnoverTo;
        }

        if (requestParameters.turnoverMax !== undefined) {
            queryParameters['TurnoverMax'] = requestParameters.turnoverMax;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['Offset'] = requestParameters.offset;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['Order'] = requestParameters.order;
        }

        if (requestParameters.orderDirection !== undefined) {
            queryParameters['OrderDirection'] = requestParameters.orderDirection;
        }

        if (requestParameters.searchByAddresses !== undefined) {
            queryParameters['SearchByAddresses'] = requestParameters.searchByAddresses;
        }

        if (requestParameters.fullSearch !== undefined) {
            queryParameters['FullSearch'] = requestParameters.fullSearch;
        }

        if (requestParameters.searchContains !== undefined) {
            queryParameters['SearchContains'] = requestParameters.searchContains;
        }

        if (requestParameters.searchExact !== undefined) {
            queryParameters['SearchExact'] = requestParameters.searchExact;
        }

        if (requestParameters.addressType !== undefined) {
            queryParameters['AddressType'] = requestParameters.addressType;
        }

        if (requestParameters.officeIds) {
            queryParameters['OfficeIds'] = requestParameters.officeIds;
        }

        if (requestParameters.companyIds) {
            queryParameters['CompanyIds'] = requestParameters.companyIds;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.countOnly !== undefined) {
            queryParameters['CountOnly'] = requestParameters.countOnly;
        }

        if (requestParameters.address !== undefined) {
            queryParameters['Address'] = requestParameters.address;
        }

        if (requestParameters.cities) {
            queryParameters['Cities'] = requestParameters.cities;
        }

        if (requestParameters.includeDetails !== undefined) {
            queryParameters['IncludeDetails'] = requestParameters.includeDetails;
        }

        if (requestParameters.fromCompanySearchFocus !== undefined) {
            queryParameters['FromCompanySearchFocus'] = requestParameters.fromCompanySearchFocus;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['FileName'] = requestParameters.fileName;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.fromFavorites !== undefined) {
            queryParameters['FromFavorites'] = requestParameters.fromFavorites;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/ExportSavedCompanies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exportSavedCompanies(requestParameters: ExportSavedCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exportSavedCompaniesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exportToMyDocumentsRaw(requestParameters: ExportToMyDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponse>> {
        const queryParameters: any = {};

        if (requestParameters.country !== undefined) {
            queryParameters['Country'] = requestParameters.country;
        }

        if (requestParameters.companyNames) {
            queryParameters['CompanyNames'] = requestParameters.companyNames;
        }

        if (requestParameters.companyName !== undefined) {
            queryParameters['CompanyName'] = requestParameters.companyName;
        }

        if (requestParameters.partialIndustryCode !== undefined) {
            queryParameters['PartialIndustryCode'] = requestParameters.partialIndustryCode;
        }

        if (requestParameters.industryCodes) {
            queryParameters['IndustryCodes'] = requestParameters.industryCodes;
        }

        if (requestParameters.municipalities) {
            queryParameters['Municipalities'] = requestParameters.municipalities;
        }

        if (requestParameters.postalCode !== undefined) {
            queryParameters['PostalCode'] = requestParameters.postalCode;
        }

        if (requestParameters.postalCodeEnd !== undefined) {
            queryParameters['PostalCodeEnd'] = requestParameters.postalCodeEnd;
        }

        if (requestParameters.postalCodeIn !== undefined) {
            queryParameters['PostalCodeIn'] = requestParameters.postalCodeIn;
        }

        if (requestParameters.latitude !== undefined) {
            queryParameters['Latitude'] = requestParameters.latitude;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['Longitude'] = requestParameters.longitude;
        }

        if (requestParameters.latitude2 !== undefined) {
            queryParameters['Latitude2'] = requestParameters.latitude2;
        }

        if (requestParameters.longitude2 !== undefined) {
            queryParameters['Longitude2'] = requestParameters.longitude2;
        }

        if (requestParameters.maxDistance !== undefined) {
            queryParameters['MaxDistance'] = requestParameters.maxDistance;
        }

        if (requestParameters.staffNumberFrom !== undefined) {
            queryParameters['StaffNumberFrom'] = requestParameters.staffNumberFrom;
        }

        if (requestParameters.staffNumberTo !== undefined) {
            queryParameters['StaffNumberTo'] = requestParameters.staffNumberTo;
        }

        if (requestParameters.staffNumberMax !== undefined) {
            queryParameters['StaffNumberMax'] = requestParameters.staffNumberMax;
        }

        if (requestParameters.turnoverFrom !== undefined) {
            queryParameters['TurnoverFrom'] = requestParameters.turnoverFrom;
        }

        if (requestParameters.turnoverTo !== undefined) {
            queryParameters['TurnoverTo'] = requestParameters.turnoverTo;
        }

        if (requestParameters.turnoverMax !== undefined) {
            queryParameters['TurnoverMax'] = requestParameters.turnoverMax;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['Offset'] = requestParameters.offset;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['Order'] = requestParameters.order;
        }

        if (requestParameters.orderDirection !== undefined) {
            queryParameters['OrderDirection'] = requestParameters.orderDirection;
        }

        if (requestParameters.searchByAddresses !== undefined) {
            queryParameters['SearchByAddresses'] = requestParameters.searchByAddresses;
        }

        if (requestParameters.fullSearch !== undefined) {
            queryParameters['FullSearch'] = requestParameters.fullSearch;
        }

        if (requestParameters.searchContains !== undefined) {
            queryParameters['SearchContains'] = requestParameters.searchContains;
        }

        if (requestParameters.searchExact !== undefined) {
            queryParameters['SearchExact'] = requestParameters.searchExact;
        }

        if (requestParameters.addressType !== undefined) {
            queryParameters['AddressType'] = requestParameters.addressType;
        }

        if (requestParameters.officeIds) {
            queryParameters['OfficeIds'] = requestParameters.officeIds;
        }

        if (requestParameters.companyIds) {
            queryParameters['CompanyIds'] = requestParameters.companyIds;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.countOnly !== undefined) {
            queryParameters['CountOnly'] = requestParameters.countOnly;
        }

        if (requestParameters.address !== undefined) {
            queryParameters['Address'] = requestParameters.address;
        }

        if (requestParameters.cities) {
            queryParameters['Cities'] = requestParameters.cities;
        }

        if (requestParameters.includeDetails !== undefined) {
            queryParameters['IncludeDetails'] = requestParameters.includeDetails;
        }

        if (requestParameters.fromCompanySearchFocus !== undefined) {
            queryParameters['FromCompanySearchFocus'] = requestParameters.fromCompanySearchFocus;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['FileName'] = requestParameters.fileName;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.fromFavorites !== undefined) {
            queryParameters['FromFavorites'] = requestParameters.fromFavorites;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/ExportToMyDocuments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseFromJSON(jsonValue));
    }

    /**
     */
    async exportToMyDocuments(requestParameters: ExportToMyDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponse> {
        const response = await this.exportToMyDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFiltersRaw(requestParameters: GetFiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalFilterResponse>> {
        const queryParameters: any = {};

        if (requestParameters.country !== undefined) {
            queryParameters['country'] = requestParameters.country;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/GetFilters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalFilterResponseFromJSON(jsonValue));
    }

    /**
     */
    async getFilters(requestParameters: GetFiltersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalFilterResponse> {
        const response = await this.getFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFinancialStatementsRaw(requestParameters: GetFinancialStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.country !== undefined) {
            queryParameters['Country'] = requestParameters.country;
        }

        if (requestParameters.companyNames) {
            queryParameters['CompanyNames'] = requestParameters.companyNames;
        }

        if (requestParameters.companyName !== undefined) {
            queryParameters['CompanyName'] = requestParameters.companyName;
        }

        if (requestParameters.partialIndustryCode !== undefined) {
            queryParameters['PartialIndustryCode'] = requestParameters.partialIndustryCode;
        }

        if (requestParameters.industryCodes) {
            queryParameters['IndustryCodes'] = requestParameters.industryCodes;
        }

        if (requestParameters.municipalities) {
            queryParameters['Municipalities'] = requestParameters.municipalities;
        }

        if (requestParameters.postalCode !== undefined) {
            queryParameters['PostalCode'] = requestParameters.postalCode;
        }

        if (requestParameters.postalCodeEnd !== undefined) {
            queryParameters['PostalCodeEnd'] = requestParameters.postalCodeEnd;
        }

        if (requestParameters.postalCodeIn !== undefined) {
            queryParameters['PostalCodeIn'] = requestParameters.postalCodeIn;
        }

        if (requestParameters.latitude !== undefined) {
            queryParameters['Latitude'] = requestParameters.latitude;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['Longitude'] = requestParameters.longitude;
        }

        if (requestParameters.latitude2 !== undefined) {
            queryParameters['Latitude2'] = requestParameters.latitude2;
        }

        if (requestParameters.longitude2 !== undefined) {
            queryParameters['Longitude2'] = requestParameters.longitude2;
        }

        if (requestParameters.maxDistance !== undefined) {
            queryParameters['MaxDistance'] = requestParameters.maxDistance;
        }

        if (requestParameters.staffNumberFrom !== undefined) {
            queryParameters['StaffNumberFrom'] = requestParameters.staffNumberFrom;
        }

        if (requestParameters.staffNumberTo !== undefined) {
            queryParameters['StaffNumberTo'] = requestParameters.staffNumberTo;
        }

        if (requestParameters.staffNumberMax !== undefined) {
            queryParameters['StaffNumberMax'] = requestParameters.staffNumberMax;
        }

        if (requestParameters.turnoverFrom !== undefined) {
            queryParameters['TurnoverFrom'] = requestParameters.turnoverFrom;
        }

        if (requestParameters.turnoverTo !== undefined) {
            queryParameters['TurnoverTo'] = requestParameters.turnoverTo;
        }

        if (requestParameters.turnoverMax !== undefined) {
            queryParameters['TurnoverMax'] = requestParameters.turnoverMax;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['Offset'] = requestParameters.offset;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['Order'] = requestParameters.order;
        }

        if (requestParameters.orderDirection !== undefined) {
            queryParameters['OrderDirection'] = requestParameters.orderDirection;
        }

        if (requestParameters.searchByAddresses !== undefined) {
            queryParameters['SearchByAddresses'] = requestParameters.searchByAddresses;
        }

        if (requestParameters.fullSearch !== undefined) {
            queryParameters['FullSearch'] = requestParameters.fullSearch;
        }

        if (requestParameters.searchContains !== undefined) {
            queryParameters['SearchContains'] = requestParameters.searchContains;
        }

        if (requestParameters.searchExact !== undefined) {
            queryParameters['SearchExact'] = requestParameters.searchExact;
        }

        if (requestParameters.addressType !== undefined) {
            queryParameters['AddressType'] = requestParameters.addressType;
        }

        if (requestParameters.officeIds) {
            queryParameters['OfficeIds'] = requestParameters.officeIds;
        }

        if (requestParameters.companyIds) {
            queryParameters['CompanyIds'] = requestParameters.companyIds;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.countOnly !== undefined) {
            queryParameters['CountOnly'] = requestParameters.countOnly;
        }

        if (requestParameters.address !== undefined) {
            queryParameters['Address'] = requestParameters.address;
        }

        if (requestParameters.cities) {
            queryParameters['Cities'] = requestParameters.cities;
        }

        if (requestParameters.includeDetails !== undefined) {
            queryParameters['IncludeDetails'] = requestParameters.includeDetails;
        }

        if (requestParameters.fromCompanySearchFocus !== undefined) {
            queryParameters['FromCompanySearchFocus'] = requestParameters.fromCompanySearchFocus;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['FileName'] = requestParameters.fileName;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.fromFavorites !== undefined) {
            queryParameters['FromFavorites'] = requestParameters.fromFavorites;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/GetFinancialStatements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getFinancialStatements(requestParameters: GetFinancialStatementsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getFinancialStatementsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getMapAheadRaw(requestParameters: GetMapAheadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MapAheadResponse>> {
        const queryParameters: any = {};

        if (requestParameters.country !== undefined) {
            queryParameters['Country'] = requestParameters.country;
        }

        if (requestParameters.companyNames) {
            queryParameters['CompanyNames'] = requestParameters.companyNames;
        }

        if (requestParameters.companyName !== undefined) {
            queryParameters['CompanyName'] = requestParameters.companyName;
        }

        if (requestParameters.partialIndustryCode !== undefined) {
            queryParameters['PartialIndustryCode'] = requestParameters.partialIndustryCode;
        }

        if (requestParameters.industryCodes) {
            queryParameters['IndustryCodes'] = requestParameters.industryCodes;
        }

        if (requestParameters.municipalities) {
            queryParameters['Municipalities'] = requestParameters.municipalities;
        }

        if (requestParameters.postalCode !== undefined) {
            queryParameters['PostalCode'] = requestParameters.postalCode;
        }

        if (requestParameters.postalCodeEnd !== undefined) {
            queryParameters['PostalCodeEnd'] = requestParameters.postalCodeEnd;
        }

        if (requestParameters.postalCodeIn !== undefined) {
            queryParameters['PostalCodeIn'] = requestParameters.postalCodeIn;
        }

        if (requestParameters.latitude !== undefined) {
            queryParameters['Latitude'] = requestParameters.latitude;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['Longitude'] = requestParameters.longitude;
        }

        if (requestParameters.latitude2 !== undefined) {
            queryParameters['Latitude2'] = requestParameters.latitude2;
        }

        if (requestParameters.longitude2 !== undefined) {
            queryParameters['Longitude2'] = requestParameters.longitude2;
        }

        if (requestParameters.maxDistance !== undefined) {
            queryParameters['MaxDistance'] = requestParameters.maxDistance;
        }

        if (requestParameters.staffNumberFrom !== undefined) {
            queryParameters['StaffNumberFrom'] = requestParameters.staffNumberFrom;
        }

        if (requestParameters.staffNumberTo !== undefined) {
            queryParameters['StaffNumberTo'] = requestParameters.staffNumberTo;
        }

        if (requestParameters.staffNumberMax !== undefined) {
            queryParameters['StaffNumberMax'] = requestParameters.staffNumberMax;
        }

        if (requestParameters.turnoverFrom !== undefined) {
            queryParameters['TurnoverFrom'] = requestParameters.turnoverFrom;
        }

        if (requestParameters.turnoverTo !== undefined) {
            queryParameters['TurnoverTo'] = requestParameters.turnoverTo;
        }

        if (requestParameters.turnoverMax !== undefined) {
            queryParameters['TurnoverMax'] = requestParameters.turnoverMax;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['Offset'] = requestParameters.offset;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['Order'] = requestParameters.order;
        }

        if (requestParameters.orderDirection !== undefined) {
            queryParameters['OrderDirection'] = requestParameters.orderDirection;
        }

        if (requestParameters.searchByAddresses !== undefined) {
            queryParameters['SearchByAddresses'] = requestParameters.searchByAddresses;
        }

        if (requestParameters.fullSearch !== undefined) {
            queryParameters['FullSearch'] = requestParameters.fullSearch;
        }

        if (requestParameters.searchContains !== undefined) {
            queryParameters['SearchContains'] = requestParameters.searchContains;
        }

        if (requestParameters.searchExact !== undefined) {
            queryParameters['SearchExact'] = requestParameters.searchExact;
        }

        if (requestParameters.addressType !== undefined) {
            queryParameters['AddressType'] = requestParameters.addressType;
        }

        if (requestParameters.officeIds) {
            queryParameters['OfficeIds'] = requestParameters.officeIds;
        }

        if (requestParameters.companyIds) {
            queryParameters['CompanyIds'] = requestParameters.companyIds;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.countOnly !== undefined) {
            queryParameters['CountOnly'] = requestParameters.countOnly;
        }

        if (requestParameters.address !== undefined) {
            queryParameters['Address'] = requestParameters.address;
        }

        if (requestParameters.cities) {
            queryParameters['Cities'] = requestParameters.cities;
        }

        if (requestParameters.includeDetails !== undefined) {
            queryParameters['IncludeDetails'] = requestParameters.includeDetails;
        }

        if (requestParameters.fromCompanySearchFocus !== undefined) {
            queryParameters['FromCompanySearchFocus'] = requestParameters.fromCompanySearchFocus;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['FileName'] = requestParameters.fileName;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.fromFavorites !== undefined) {
            queryParameters['FromFavorites'] = requestParameters.fromFavorites;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/GetMapAhead`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MapAheadResponseFromJSON(jsonValue));
    }

    /**
     */
    async getMapAhead(requestParameters: GetMapAheadRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MapAheadResponse> {
        const response = await this.getMapAheadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSavedCompaniesRaw(requestParameters: GetSavedCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SearchResultCollection>>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/GetSavedCompanies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchResultCollectionFromJSON));
    }

    /**
     */
    async getSavedCompanies(requestParameters: GetSavedCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SearchResultCollection>> {
        const response = await this.getSavedCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultCollection>> {
        const queryParameters: any = {};

        if (requestParameters.country !== undefined) {
            queryParameters['Country'] = requestParameters.country;
        }

        if (requestParameters.companyNames) {
            queryParameters['CompanyNames'] = requestParameters.companyNames;
        }

        if (requestParameters.companyName !== undefined) {
            queryParameters['CompanyName'] = requestParameters.companyName;
        }

        if (requestParameters.partialIndustryCode !== undefined) {
            queryParameters['PartialIndustryCode'] = requestParameters.partialIndustryCode;
        }

        if (requestParameters.industryCodes) {
            queryParameters['IndustryCodes'] = requestParameters.industryCodes;
        }

        if (requestParameters.municipalities) {
            queryParameters['Municipalities'] = requestParameters.municipalities;
        }

        if (requestParameters.postalCode !== undefined) {
            queryParameters['PostalCode'] = requestParameters.postalCode;
        }

        if (requestParameters.postalCodeEnd !== undefined) {
            queryParameters['PostalCodeEnd'] = requestParameters.postalCodeEnd;
        }

        if (requestParameters.postalCodeIn !== undefined) {
            queryParameters['PostalCodeIn'] = requestParameters.postalCodeIn;
        }

        if (requestParameters.latitude !== undefined) {
            queryParameters['Latitude'] = requestParameters.latitude;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['Longitude'] = requestParameters.longitude;
        }

        if (requestParameters.latitude2 !== undefined) {
            queryParameters['Latitude2'] = requestParameters.latitude2;
        }

        if (requestParameters.longitude2 !== undefined) {
            queryParameters['Longitude2'] = requestParameters.longitude2;
        }

        if (requestParameters.maxDistance !== undefined) {
            queryParameters['MaxDistance'] = requestParameters.maxDistance;
        }

        if (requestParameters.staffNumberFrom !== undefined) {
            queryParameters['StaffNumberFrom'] = requestParameters.staffNumberFrom;
        }

        if (requestParameters.staffNumberTo !== undefined) {
            queryParameters['StaffNumberTo'] = requestParameters.staffNumberTo;
        }

        if (requestParameters.staffNumberMax !== undefined) {
            queryParameters['StaffNumberMax'] = requestParameters.staffNumberMax;
        }

        if (requestParameters.turnoverFrom !== undefined) {
            queryParameters['TurnoverFrom'] = requestParameters.turnoverFrom;
        }

        if (requestParameters.turnoverTo !== undefined) {
            queryParameters['TurnoverTo'] = requestParameters.turnoverTo;
        }

        if (requestParameters.turnoverMax !== undefined) {
            queryParameters['TurnoverMax'] = requestParameters.turnoverMax;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['Offset'] = requestParameters.offset;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['Order'] = requestParameters.order;
        }

        if (requestParameters.orderDirection !== undefined) {
            queryParameters['OrderDirection'] = requestParameters.orderDirection;
        }

        if (requestParameters.searchByAddresses !== undefined) {
            queryParameters['SearchByAddresses'] = requestParameters.searchByAddresses;
        }

        if (requestParameters.fullSearch !== undefined) {
            queryParameters['FullSearch'] = requestParameters.fullSearch;
        }

        if (requestParameters.searchContains !== undefined) {
            queryParameters['SearchContains'] = requestParameters.searchContains;
        }

        if (requestParameters.searchExact !== undefined) {
            queryParameters['SearchExact'] = requestParameters.searchExact;
        }

        if (requestParameters.addressType !== undefined) {
            queryParameters['AddressType'] = requestParameters.addressType;
        }

        if (requestParameters.officeIds) {
            queryParameters['OfficeIds'] = requestParameters.officeIds;
        }

        if (requestParameters.companyIds) {
            queryParameters['CompanyIds'] = requestParameters.companyIds;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.countOnly !== undefined) {
            queryParameters['CountOnly'] = requestParameters.countOnly;
        }

        if (requestParameters.address !== undefined) {
            queryParameters['Address'] = requestParameters.address;
        }

        if (requestParameters.cities) {
            queryParameters['Cities'] = requestParameters.cities;
        }

        if (requestParameters.includeDetails !== undefined) {
            queryParameters['IncludeDetails'] = requestParameters.includeDetails;
        }

        if (requestParameters.fromCompanySearchFocus !== undefined) {
            queryParameters['FromCompanySearchFocus'] = requestParameters.fromCompanySearchFocus;
        }

        if (requestParameters.fileName !== undefined) {
            queryParameters['FileName'] = requestParameters.fileName;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.fromFavorites !== undefined) {
            queryParameters['FromFavorites'] = requestParameters.fromFavorites;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/Search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultCollectionFromJSON(jsonValue));
    }

    /**
     */
    async search(requestParameters: SearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultCollection> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendInternshipEmailToCounsellorRaw(requestParameters: SendInternshipEmailToCounsellorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/SendInternshipEmailToCounsellor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanySearchInternshipEmailToJSON(requestParameters.companySearchInternshipEmail),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendInternshipEmailToCounsellor(requestParameters: SendInternshipEmailToCounsellorRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendInternshipEmailToCounsellorRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateSavedCompanyRaw(requestParameters: UpdateSavedCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['UserId'] = requestParameters.userId;
        }

        if (requestParameters.companyId !== undefined) {
            queryParameters['CompanyId'] = requestParameters.companyId;
        }

        if (requestParameters.officeId !== undefined) {
            queryParameters['OfficeId'] = requestParameters.officeId;
        }

        if (requestParameters.companyCountry !== undefined) {
            queryParameters['CompanyCountry'] = requestParameters.companyCountry;
        }

        if (requestParameters.note !== undefined) {
            queryParameters['Note'] = requestParameters.note;
        }

        if (requestParameters.isInsertedMainCompany !== undefined) {
            queryParameters['isInsertedMainCompany'] = requestParameters.isInsertedMainCompany;
        }

        if (requestParameters.vainuCompany !== undefined) {
            queryParameters['VainuCompany'] = requestParameters.vainuCompany;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/CompanySearchApi/UpdateSavedCompany`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async updateSavedCompany(requestParameters: UpdateSavedCompanyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updateSavedCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
